import { createSlice } from '@reduxjs/toolkit'
import { createAsyncThunk } from '@reduxjs/toolkit'
import axios, { AxiosError } from 'axios'

import { fetchDocuments, updateDocuments } from './documentsApi'
import { DocumentActions, IDocumentsState } from './types'

const initialState: IDocumentsState = {
  documentsList: {
    count: 0,
    current: 0,
    next: null,
    page_count: 0,
    previous: null,
    results: [],
    loading: false,
  },
}

export const fetchDocumentsThunk = createAsyncThunk(
  DocumentActions.FETCH_DOCUMENTS,
  async ({ page }: { page?: number }, { rejectWithValue }) => {
    try {
      const response = await fetchDocuments(page)
      return response.data
    } catch (error: unknown) {
      const axiosError = error as AxiosError
      return rejectWithValue(axiosError.response?.data || axiosError.message)
    }
  }
)

export const updateDocumentsThunk = createAsyncThunk(
  DocumentActions.UPDATE_DOCUMENTS,
  async (_, { rejectWithValue }) => {
    try {
      const response = await updateDocuments()
      return response.data
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return rejectWithValue(error.response?.data || error.message)
      } else {
        return rejectWithValue('An unexpected error occurred')
      }
    }
  }
)

const closeDocumentsSlice = createSlice({
  name: DocumentActions.SLICE_NAME,
  initialState,
  reducers: {
    setDocumentsLoading(state) {
      state.documentsList.loading = true
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDocumentsThunk.pending, (state) => {
        state.documentsList.loading = true
      })
      .addCase(fetchDocumentsThunk.fulfilled, (state, action) => {
        const { results, ...listParams } = action.payload
        state.documentsList = {
          ...listParams,
          loading: false,
          results: [...state.documentsList.results, ...results],
        }
      })
      .addCase(fetchDocumentsThunk.rejected, (state) => {
        state.documentsList.loading = false
      })
      .addCase(updateDocumentsThunk.pending, (state) => {
        state.documentsList.loading = true
      })
      .addCase(updateDocumentsThunk.fulfilled, (state, action) => {
        state.documentsList = {
          ...action.payload,
          loading: false,
        }
      })
      .addCase(updateDocumentsThunk.rejected, (state) => {
        state.documentsList.loading = false
      })
  },
})

export const { setDocumentsLoading } = closeDocumentsSlice.actions
export default closeDocumentsSlice.reducer
